import { createAsyncThunk, createSlice, } from '@reduxjs/toolkit'
import { AppState } from '@app/store/state/app.state';
import { requestUsersHolidayOverview } from '@features/holidays/services/HolidayService';
import moment from 'moment';

export interface HolidaysState {
  usersUpcomingHolidays: any[];
  usersPreviousHolidays: any[];
  holidaysBooked: number;
  remainingAllowance: number;
  totalAllowance: number;
  loading: boolean;
  upcomingCompanyHolidays: any[];
}

export const initialHolidays: HolidaysState = {
  usersPreviousHolidays: [],
  usersUpcomingHolidays: [],
  holidaysBooked: 0,
  remainingAllowance: 0,
  totalAllowance: 0,
  loading: false,
  upcomingCompanyHolidays: [],
}

const loadUsersHolidays: any = createAsyncThunk(
  'holidays/loadUsersHolidays',
  async (force: any, thunkAPI) => {

    const overview = await requestUsersHolidayOverview();
    const today = moment();

    const previous = overview.holidays.filter(h => h.getToDate().isBefore(today));
    const upcoming = overview.holidays.filter(h => !previous.includes(h));

    return {
      remainingAllowance: overview.daysRemaining,
      holidaysBooked: overview.daysTaken,
      totalAllowance: overview.totalAllowance,
      previous, upcoming
    }
  }
);

const holidaysSlice = createSlice({
  name: 'holidays',
  initialState: initialHolidays,
  reducers: {
    reset: () => initialHolidays,
    setHolidayView: (state, action) => ({
      ...state,
      activeView: action.payload,
    }),
    clearHolidays: () => initialHolidays
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadUsersHolidays.pending, (state) => ({...state, loading: true, }))
      .addCase(loadUsersHolidays.rejected, (state) => ({...state, loading: false, }))
      .addCase(loadUsersHolidays.fulfilled, (state, action) => ({
      ...state,
      loading: false,
      usersUpcomingHolidays: action.payload.upcoming,
      usersPreviousHolidays: action.payload.previous,
      holidaysBooked: action.payload.holidaysBooked,
      remainingAllowance: action.payload.remainingAllowance,
      totalAllowance: action.payload.totalAllowance,
    }));
  }
});


export default holidaysSlice.reducer;

// Selectors
const selectUpcomingCompanyHolidays = (state: AppState) => state.holidays.upcomingCompanyHolidays;
